import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@mui/material";
import { addNewBlogRequest } from "api/blogs";
import UploadCm from "components/AdvsUploadCm";
import BackButton from "components/shared/BackButton";
import DrawerCM from "components/shared/Drawer";
import EditorCm from "components/shared/EditorCm";
import LoadingCM from "components/shared/Loading";
import ProgressBarCM from "components/shared/ProgressBar";
import StackCm from "components/shared/StackCm";
import TextFieldCm from "components/shared/TextField";
import { categoriesData } from "constants/category";
import Toast from "helper/toast";
import useHttp from "hooks/use-http";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { StyledGlBtn } from "styles/globals";
import { validateImg } from "validations";
import blogsSchema from "validations/blogs";

const INPUTS = [
  {
    id: "title",
    label: "عنوان",
  },
  {
    id: "time",
    label: "زمان مورد نیاز",
  },
  {
    id: "blog_category_id",
    label: "محله",
    selectItems: categoriesData,
    type: "select",
  },
];

export default function AddNewBlog() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({ resolver: yupResolver(blogsSchema) });

  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);

  // editor value
  const [text, setText] = useState("");
  const [image, setImage] = useState("");

  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        addNewBlogRequest(
          {
            ...data,
            description: text,
            image: image?.url,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });
    if (res) {
      Toast({ type: "success", title: "افزودن وبلاگ" });
      navigate(-1);
    }
  };

  return (
    <DrawerCM title="افزودن وبلاگ">
      <Grid item xs={12} mt={3}>
        <BackButton />
      </Grid>
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <StackCm title="فیلد های وبلاگ">
          <Grid container>
            {INPUTS.map((input) => (
              <Grid key={input.id} item md={4} sm={6} xs={12} p={1.5}>
                <TextFieldCm
                  {...input}
                  register={register}
                  errors={errors}
                  control={control}
                />
              </Grid>
            ))}
            <Grid item md={4} sm={6} xs={12} p={1.5}>
              <TextFieldCm
                id={"blog_subcategory_id"}
                type={"select"}
                label={"زیردسته"}
                selectItems={
                  watch("blog_category_id") == 1
                    ? categoriesData[0].subCategories
                    : []
                }
                register={register}
                errors={errors}
                control={control}
              />
            </Grid>
            <Grid item md={12} xs={12} p={1.5}>
              <UploadCm
                title={"بارگزاری عکس وبلاگ"}
                id={"image"}
                state={image}
                setState={setImage}
              />
            </Grid>
            <Grid item md={4} xs={12} p={1.5}>
              <TextFieldCm
                id={"alt"}
                label={"متن جایگزین (alt)"}
                register={register}
                errors={errors}
              />
            </Grid>
            <Grid item xs={12} p={1.5}>
              <EditorCm state={text} setState={setText} />
            </Grid>
            {[
              {
                id: "keyword",
                label: "کلمات کلیدی (سئو)",
              },
              {
                id: "meta_description",
                label: "توضیحات (سئو)",
              },
            ].map((input) => (
              <Grid
                key={input.id}
                item
                md={input.id === "meta_description" ? 8 : 4}
                xs={12}
                p={1.5}
              >
                <TextFieldCm
                  {...input}
                  register={register}
                  errors={errors}
                  control={control}
                />
              </Grid>
            ))}

            <StyledGlBtn onClick={handleSubmit(onSubmit)} />
          </Grid>
        </StackCm>
      )}
    </DrawerCM>
  );
}
